import React from 'react';
import { CommonIconProps } from './Icon';

const Caret = ({ color }: CommonIconProps): JSX.Element => (
  <>
    <path
      d="M13.4142 15.4142C12.6332 16.1953 11.3668 16.1953 10.5858 15.4142C8.82335 13.6518 8.34822 13.1766 6.58579 11.4142C5.80474 10.6332 5.80474 9.36683 6.58579 8.58579C6.97631 8.19526 7.48816 8 8 8H16C16.5118 8 17.0237 8.19526 17.4142 8.58579C18.1953 9.36683 18.1953 10.6332 17.4142 11.4142C15.6518 13.1766 15.1766 13.6518 13.4142 15.4142Z"
      fill={color}
    />
  </>
);

export default Caret;
